/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import lock_icon from "../../../../assets/images/padlock.png";
import { RouteNames } from "../../../../routes/routes";

import "./BloqueioDesignCartao.css";
import { fetchReemissaoCartao } from "redux/features/cliente/cliente-slice";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import ContainerFlex from "components/ContainerFlex";
import Checkbox from "components/checkbox";

import Button from "components/button";
import { LOCAL_STORE_CLIENTE } from "../../../../constants";
import { getItemLocalStore } from "utils/storeUtils";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { TIPO_CARTAO_CONVENIO, TipoCartao } from "models/tipoCartao";

const BloqueioDesignCartao = () => {
  const history = useHistory();
  const { state } = useLocation<{
    numeroCartao: string;
    tipoCartaoSelecionado?: TipoCartao;
  }>();
  const tipoCartaoSelecionado = state?.tipoCartaoSelecionado;
  const { dadosLogin } = getItemLocalStore(LOCAL_STORE_CLIENTE);
  const tokenCartao =
    tipoCartaoSelecionado === TIPO_CARTAO_CONVENIO
      ? dadosLogin?.tokenCartaoConvenio
      : dadosLogin?.tokenCartao;
  const [temacartao, setTemaCartao] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [cardInfos, setCardInfos] = useState<any>([]);
  const dispatch = useAppDispatch();
  const {
    cliente: { segundaViaSucesso },
  } = useAppSelector((state) => state);

  const handleReemisaoCartao = () => {
    dispatch(setLoading(true));
    dispatch(
      setTitleLoading("Estamos gerando tua 2º via do cartão, aguarde..."),
    );
    dispatch(
      fetchReemissaoCartao({
        numeroCartao: state?.numeroCartao,
        taxa: true,
        temaDoCartao: temacartao,
      }),
    );
  };

  const GetCurrentCategory = useApi<any>(
    Endpoints.autorizador.getClientCurrentyCategoryTokenCartao.replace(
      "PARAM_TOKEN",
      tokenCartao,
    ),
    ApiMethod.GET,
  );

  useEffect(() => {
    const getInfoCards = async () => {
      try {
        const response = await GetCurrentCategory.callApi();
        if (response.status >= 200) {
          const data = response.data.data;
          setCardInfos(data);

          if (Array.isArray(data) && data.length === 1) {
            setTemaCartao(data[0].modeloTema);
            setDisabled(false);
          } else if (!Array.isArray(data) && data?.modeloTema) {
            setTemaCartao(data.modeloTema);
            setDisabled(false);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    getInfoCards();
  }, []);

  const handleCancel = () => {
    history.push({
      pathname: RouteNames.BLOQUEIO_QUER_SEGUNDA_VIA,
      state: { tipoCartaoSelecionado },
    });
  };

  useEffect(() => {
    if (segundaViaSucesso) {
      history.push(`${RouteNames.BLOQUEIO_CARTAO_CONCLUIDO}/true`);
    }
  }, [segundaViaSucesso, temacartao]);

  return (
    <div className="design-cartao-main">
      <h1 id="design-cartao-title">2º via do cartão</h1>
      <p className="description">
        Por favor, escolha o design do teu novo cartão.
      </p>

      <div className="design-cartao-content">
        {Array.isArray(cardInfos) ? (
          cardInfos.map((el, index) => (
            <button
              key={index}
              onClick={() => {
                setTemaCartao(el.modeloTema);
                setDisabled(false);
              }}
            >
              <div onClick={(e) => e.stopPropagation()}>
                <Checkbox
                  value={temacartao === el.modeloTema}
                  onStatus={(e: any) => {
                    setDisabled(e);
                    setTemaCartao(e ? "" : el.modeloTema);
                  }}
                />
              </div>
              <img
                src={el.urlImagem}
                alt={`Imagem ${el.modeloTema}`}
                onClick={(e: any) => {
                  e.stopPropagation();
                  if (temacartao === el.modeloTema && !disabled) {
                    setDisabled(true);
                    setTemaCartao("");
                  } else {
                    setDisabled(false);
                    setTemaCartao(el.modeloTema);
                  }
                }}
              />
            </button>
          ))
        ) : (
          <button
            onClick={() => {
              setTemaCartao(cardInfos.modeloTema);
              setDisabled(false);
            }}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <Checkbox
                value={temacartao === cardInfos.modeloTema}
                onStatus={(e: any) => {
                  setDisabled(e);
                  setTemaCartao(e ? "" : cardInfos.modeloTema);
                }}
              />
            </div>
            <img
              src={cardInfos?.urlImagem}
              alt={`Imagem ${cardInfos?.modeloTema}`}
              onClick={(e: any) => {
                e.stopPropagation();
                if (temacartao === cardInfos?.modeloTema && !disabled) {
                  setDisabled(true);
                  setTemaCartao("");
                } else {
                  setDisabled(false);
                  setTemaCartao(cardInfos.modeloTema);
                }
              }}
            />
          </button>
        )}
      </div>
      <ContainerFlex center marginTop={10}>
        <ContainerFlex row horizontal>
          <ContainerFlex>
            <Button onClick={() => handleCancel()} size="large" outlined>
              <span>Voltar</span>
            </Button>
          </ContainerFlex>

          <ContainerFlex end align="flex-end">
            <Button
              onClick={handleReemisaoCartao}
              size="large"
              disabled={disabled}
            >
              <span>Continuar</span>
            </Button>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>

      <img id="design-cartao-padlock" src={lock_icon} alt="" />
    </div>
  );
};

export default BloqueioDesignCartao;
